import {CloseCircleFilled as AntdCloseCircleFilled} from '@ant-design/icons';

export default function CloseCircleFilled(props) {
  return <AntdCloseCircleFilled {...props} />;
}
